import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app.js";
import "./styles/global.css";
import { AdminProvider } from "./context/AdminContext.js";  // ✅ import your AdminProvider

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AdminProvider> {/* ✅ wrap App inside AdminProvider */}
      <App />
    </AdminProvider>
  </React.StrictMode>
);
